import { FC } from 'react';

import { useProcessedProblems } from '../../../studentApp/hooks';
import { NormalProblem } from '../../../studentApp/stores';
import { NormalBox } from '../../../studentApp/views/student/boxes/normalBox';
import { RegionLabel } from '../squares/regionLabel';

export const CurrentSkillDetails: FC = () => {
  const problem = useProcessedProblems().currentProblem as
    | NormalProblem
    | undefined;

  const text = 'Current Skill';
  const penalties = problem?.penalty || 0;
  const penaltyMessage =
    penalties === 0
      ? ''
      : `${penalties} ${penalties === 1 ? 'Penalty' : 'Penalties'}`;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      }}
    >
      <RegionLabel text={text} />
      <NormalBox
        problem={problem as NormalProblem}
        key={problem?.id}
        replica={true}
      />
      {penalties > 0 && <div>{penaltyMessage}</div>}
    </div>
  );
};
